(() => {
  const EMBROIDERY_VALUE = 'EMBROIDERY (+$3.00 per item)';

  const updateCustomizer = (customizer) => {
    const selectedMethod = customizer.querySelector('input[name="properties[Print Method]"]:checked')?.value;
    const showDigitising = selectedMethod === EMBROIDERY_VALUE;

    customizer.querySelectorAll('.ts-native-customizer__digitising, .ts-native-customizer__digitising-note')
      .forEach((element) => { element.hidden = !showDigitising; });

    if (!showDigitising) {
      const digitising = customizer.querySelector('input[name="properties[Digitising Fee]"]');
      if (digitising) digitising.checked = false;
    }
  };

  document.addEventListener('change', (event) => {
    const customizer = event.target.closest('[data-ts-native-customizer]');
    if (!customizer) return;

    updateCustomizer(customizer);

    if (event.target.matches('[data-ts-logo-upload]')) {
      const fileName = customizer.querySelector('[data-ts-upload-file-name]');
      const selectedFile = event.target.files?.[0];
      if (fileName) {
        fileName.textContent = selectedFile ? `Selected: ${selectedFile.name}` : 'No file selected';
      }
    }
  });

  document.querySelectorAll('[data-ts-native-customizer]').forEach(updateCustomizer);
})();
